import { Tooltip, TooltipTrigger, TooltipContent } from './chunk-DIDPLGSY.js';
import { useOptionalTheme } from './chunk-77MV73QS.js';
import { Button } from './chunk-QJZK7P2F.js';
import { cn } from './chunk-FFX3LZW7.js';
import { AUTHE_ARTWORK } from '@authe/fe-commons/brand';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState } from 'react';
import { DEFAULT_BRAND_IDENTITY } from '@authe/fe-commons/theme';
import { Sun, Moon } from 'lucide-react';

function BrandGlyph(props) {
  return /* @__PURE__ */ jsx("svg", { ...props, viewBox: AUTHE_ARTWORK.viewBox, fill: "currentColor", "aria-hidden": "true", focusable: "false", "data-brand-version": AUTHE_ARTWORK.version, children: AUTHE_ARTWORK.paths.map((d, index) => /* @__PURE__ */ jsx("path", { d }, index)) });
}
var SIZE_CLASSES = {
  sm: "size-7 text-xs rounded-md",
  md: "size-9 text-sm rounded-lg",
  lg: "size-10 text-base rounded-xl"
};
function BrandMark({ className, size = "md" }) {
  const theme = useOptionalTheme();
  const brand = { ...DEFAULT_BRAND_IDENTITY, ...theme?.brand };
  const logo = theme?.resolvedMode === "dark" ? brand.logoDarkUrl ?? brand.logoUrl : brand.logoUrl;
  const [failed, setFailed] = useState();
  const isAuthe = brand.name === DEFAULT_BRAND_IDENTITY.name && brand.mark === DEFAULT_BRAND_IDENTITY.mark;
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn(
        "inline-flex shrink-0 items-center justify-center bg-brand font-bold text-brand-foreground shadow-xs select-none",
        SIZE_CLASSES[size],
        className
      ),
      "aria-hidden": true,
      children: logo && logo !== failed ? /* @__PURE__ */ jsx("img", { src: logo, alt: "", className: "size-full object-contain", onError: () => setFailed(logo) }) : isAuthe && !logo ? /* @__PURE__ */ jsx(BrandGlyph, { className: "size-full" }) : brand.mark
    }
  );
}
function ThemeToggle({
  className,
  size = "icon",
  variant = "ghost",
  withTooltip = true
}) {
  const theme = useOptionalTheme();
  if (!theme) return null;
  const { resolvedMode, setMode } = theme;
  const next = resolvedMode === "dark" ? "light" : "dark";
  const label = `Switch to ${next} theme`;
  const button = /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      variant,
      size,
      "aria-label": label,
      className: cn(
        size === "icon" ? "size-8" : "h-8 px-2",
        "text-muted-foreground transition-colors hover:text-foreground",
        className
      ),
      onClick: () => setMode(next),
      children: resolvedMode === "dark" ? /* @__PURE__ */ jsx(Sun, { className: "size-4" }) : /* @__PURE__ */ jsx(Moon, { className: "size-4" })
    }
  );
  if (!withTooltip) return button;
  return /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: button }),
    /* @__PURE__ */ jsx(TooltipContent, { side: "bottom", children: label })
  ] });
}

export { BrandGlyph, BrandMark, ThemeToggle };
//# sourceMappingURL=chunk-N2FYVRU5.js.map
//# sourceMappingURL=chunk-N2FYVRU5.js.map